/* WARNING: This file is auto-generated from Figma design tokens, do not manually update this file */

/* use "import ions from @ions;" */
import {
  ButtonVariant,
  Context,
  HostIons,
  InputBorderStyle,
  NavItemAccentType,
  PageTitleAccentType,
  PillFillStyle,
  PillVariant
} from "@ions-interface";

const ions: HostIons = {
  context: {
    fallback: Context.LIGHT,
    default: {
      primaryNav: Context.DARK,
      secondaryNav: Context.LIGHT,
      pageTitle: Context.LIGHT,
      pageBody: Context.LIGHT,
      box: Context.LIGHT,
      modal: Context.LIGHT,
      sidePanel: Context.LIGHT,
      contentDisplay: Context.DARK
    },
    clientDashboard: {
      pageTitle: Context.LIGHT,
      pageBody: Context.LIGHT,
      box: Context.LIGHT,
      modal: Context.LIGHT,
      sidePanel: Context.LIGHT,
      contentDisplay: Context.DARK
    }
  },
  components: {
    organisms: {
      workflow: { step_container: { button_variant: ButtonVariant.TEXT } },
      nav: { top: { item: { accent_type: NavItemAccentType.FOLD } } },
      modal: {
        submit: { button_variant: ButtonVariant.PRIMARY },
        cancel: { button_variant: ButtonVariant.TEXT }
      }
    },
    atoms: {
      page_title: { heading: { accent_type: PageTitleAccentType.LINE } },
      draft_pill: {
        pill_variant: PillVariant.ACCENT,
        pill_fill_style: PillFillStyle.FILLED
      }
    },
    molecules: {
      milestones: { update_button_variant: ButtonVariant.TEXT },
      project_template_panel: {
        pill_variant: PillVariant.STANDARD,
        pill_fill_style: PillFillStyle.FILLED,
        active: {
          pill_variant: PillVariant.STANDARD,
          pill_fill_style: PillFillStyle.FILLED
        }
      },
      project_panel: {
        pill_variant: PillVariant.STANDARD,
        pill_fill_style: PillFillStyle.FILLED,
        draft: {
          pill_variant: PillVariant.TRANSPARENT_DARK,
          pill_fill_style: PillFillStyle.OUTLINE
        }
      },
      inputs: {
        dropdown: {
          context_light: {
            pill_variant: PillVariant.TRANSPARENT_DARK,
            pill_fill_style: PillFillStyle.OUTLINE
          },
          context_nav: {
            pill_variant: PillVariant.TRANSPARENT_LIGHT,
            pill_fill_style: PillFillStyle.OUTLINE
          },
          context_dark: {
            pill_variant: PillVariant.TRANSPARENT_LIGHT,
            pill_fill_style: PillFillStyle.OUTLINE
          }
        }
      },
      action_item_panel: {
        pill_variant: PillVariant.STANDARD,
        pill_fill_style: PillFillStyle.FILLED
      }
    },
    templates: {
      page_filter: {
        input: { border_style: InputBorderStyle.NONE },
        pill: {
          active: {
            pill_variant: PillVariant.ACCENT,
            pill_fill_style: PillFillStyle.FILLED
          },
          inactive: {
            pill_fill_style: PillFillStyle.OUTLINE,
            pill_variant: PillVariant.TRANSPARENT_DARK
          }
        }
      },
      content_container: {
        header: { button_variant: ButtonVariant.TEXT_INVERT }
      },
      kanban: { swimlane: { action: { button_variant: ButtonVariant.TEXT } } }
    }
  }
};

export default ions;
